var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0227C0 17.9798 0.352063 19.8545 0.995188 21.5878L16 22.9792L31.0048 21.5878C31.6479 19.8545 32 17.9798 32 16.0227C32 14.0655 31.6479 12.1908 31.0048 10.4575L16 9.06615L0.995188 10.4575C0.352063 12.1908 0 14.0655 0 16.0227H0Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.004 10.4573C28.7433 4.36452 22.8786 0.0224609 15.9992 0.0224609C9.11976 0.0224609 3.25507 4.36452 0.994385 10.4573H31.004Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.994385 21.5877C3.25507 27.6804 9.11976 32.0225 15.9992 32.0225C22.8786 32.0225 28.7433 27.6804 31.004 21.5877H0.994385Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0224609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/spain.14aa2953.svg";
export { ForwardRef as ReactComponent };